import {
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_REQUEST,
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS,
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_FAILURE
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null
};

export default function deleteUserChatAndUnmatch (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request'
      };
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        timestamp: new Date().toUTCString(),
        status: 'success'
      };
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail'
      };
    default:
      return state;
  }
}
